import Home from 'pages/home';
import Landing from 'pages/landing';
import Login from 'pages/login';
import RecoverPassword from 'pages/recover-password';
import Panel from 'pages/panel';
import InstitutionPanel from 'pages/institution-panel';
import SearchStudent from 'pages/institution-panel/pages/search-student';
import StudentDetails from 'pages/institution-panel/pages/student-details';
import EmailConfirm from 'pages/email-confirm';
import TermsPolicy from 'pages/policy-pages/terms';
import PrivacityPolicy from 'pages/policy-pages/privacity';
import CookiePolicy from 'pages/policy-pages/cookie';

import dashboardRoutes from 'build/dashboard-routes';

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/entrar',
    name: 'login',
    component: Login,
  },
  {
    path: '/esqueci-minha-senha/:cpfHash',
    name: 'forgot-password',
    component: RecoverPassword,
    meta: {
      channelType: 'forgot_password',
    },
  },
  {
    path: '/primeiro-acesso/:cpfHash',
    name: 'first-access',
    component: RecoverPassword,
    meta: {
      channelType: 'first_access',
    },
  },
  {
    path: '/redefinir-senha',
    name: 'redefine-password',
    component: RecoverPassword,
    meta: {
      channelType: 'forgot_password',
    },
  },
  {
    path: '/painel-da-instituicao/:encryptedInstitutionId',
    name: 'institution-panel',
    component: InstitutionPanel,
    children: [
      {
        path: '/painel-da-instituicao/:encryptedInstitutionId',
        name: 'search-student',
        component: SearchStudent,
      },
      {
        path: 'alunos/:cpfHash',
        name: 'student-details',
        component: StudentDetails,
      },
    ],
  },
  {
    path: '/emails/:emailId/confirmar',
    name: 'email-confirm',
    component: EmailConfirm,
    meta: {
      confirmationPage: true,
    },
  },
  {
    path: '/painel',
    component: Panel,
    meta: {
      private: true,
    },
    children: [
      {
        path: '/painel',
        name: 'panel',
        component: Home,
      },
      ...dashboardRoutes,
    ],
  },
  {
    path: '/termos',
    name: 'termos',
    component: TermsPolicy,
  },
  {
    path: '/privacidade',
    name: 'privacidade',
    component: PrivacityPolicy,
  },
  {
    path: '/politica-de-cookies',
    name: 'politica-de-cookies',
    component: CookiePolicy,
  },
  { path: '*', redirect: '/' },
];

export default routes;
